<template>
  <article class="cmp cmp-product-thumb" :data-testing="item.variation.id" v-if="!hasSpecialProperty">
    <div :class="paddingClasses" :style="paddingInlineStyles">
      <div class="thumb-image">
        <div class="prop-1-1">
          <slot name="item-image">
            <category-image-carousel
              :image-urls-data="item.images | itemImages(imageUrlAccessor)"
              :alt="item | itemName"
              :title="item | itemName"
              :item-url="item | itemURL(urlWithVariationId)"
              :enable-carousel="$ceres.config.item.enableImageCarousel"
              :disable-carousel-on-mobile="disableCarouselOnMobile"
              ref="categoryImageCarousel"
            >
            </category-image-carousel>
            <!-- EnergyLabel -->
            <div v-if="energyLabelImage" class="energy-label my-2">
              <img :src="energyLabelImage" :alt="energyLabelValue" style="max-width: 80px; cursor: pointer;" @click="showEnergyLabelModal = true" />
              <div v-if="showEnergyLabelModal" class="modal fade show" tabindex="-1" style="display: block; background: rgba(0,0,0,0.5);" @click.self="showEnergyLabelModal = false">
                <div class="modal-dialog modal-lg modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">{{ $translate("stabiloVueTheme::Single.EnergyLabelModalTitle") }}</h5>
                      <button type="button" class="close" @click="showEnergyLabelModal = false">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body text-center">
                      <img :src="energyLabelModalImage" alt="EnergieLabel" style="max-width: 100%;" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /EnergyLabel -->
          </slot>
        </div>
        <!-- categoryitem-stoerer: START -->
        <div class="categoryitem-stoerer-wrapper">
          <div v-for="(propertyGroup, groupIndex) in item.variationProperties" :key="`group-${groupIndex}`">
            <!-- wenn Artikel in Kategorieansicht -->
            <div v-if="propertyGroup.property">
              <div v-if="propertyGroup.property.id == 2" class="categoryitem-sale small font-weight-bold text-white">
                <span>{{ $translate("stabiloVueTheme::Single.AdsOnly") }}</span>
              </div>
              <div v-if="propertyGroup.property.id == 12" class="categoryitem-onlineonly small font-weight-bold text-white">
                <span>{{ $translate("stabiloVueTheme::Single.OnlineOnly") }}</span>
              </div>
              <div v-if="propertyGroup.property.id == 13" class="categoryitem-storeonly small font-weight-bold text-white">
                <span>{{ $translate("stabiloVueTheme::Single.StoreOnly") }}</span>
              </div>
              <div v-if="propertyGroup.property.id == 14" class="categoryitem-temp small font-weight-bold text-white">
                <span>{{ $translate("stabiloVueTheme::Single.TempOnly") }}</span>
              </div>
            </div>
            <!-- wenn Artikel in Crossselling-Liste -->
            <div v-else>
              <div v-for="(property, propIndex) in propertyGroup.properties" :key="`prop-${groupIndex}-${propIndex}`">
                <div v-if="property.id == 2" class="categoryitem-sale small font-weight-bold text-white">
                  <span>{{ $translate("stabiloVueTheme::Single.AdsOnly") }}</span>
                </div>
                <div v-if="property.id == 12" class="categoryitem-onlineonly small font-weight-bold text-white">
                  <span>{{ $translate("stabiloVueTheme::Single.OnlineOnly") }}</span>
                </div>
                <div v-if="property.id == 13" class="categoryitem-storeonly small font-weight-bold text-white">
                  <span>{{ $translate("stabiloVueTheme::Single.StoreOnly") }}</span>
                </div>
                <div v-if="property.id == 14" class="categoryitem-temp small font-weight-bold text-white">
                  <span>{{ $translate("stabiloVueTheme::Single.TempOnly") }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- categoryitem-stoerer: END -->
      </div>
      <!-- STORE SPECIALS -->
      <slot name="store-special">
        <item-store-special
          v-if="storeSpecial || item.variation.bundleType === 'bundle' || item.item.itemType === 'set'"
          :store-special="storeSpecial"
          :recommended-retail-price="item.prices.rrp"
          :variation-retail-price="item.prices.default"
          :special-offer-price="item.prices.specialOffer"
          :decimal-count="decimalCount"
          :bundle-type="item.variation.bundleType"
          :item-type="item.item.itemType"
        >
        </item-store-special>
      </slot>
      <!-- ./STORE SPECIALS -->

      <!-- ITEM DETAILS -->
      <slot name="item-details">
        <div class="thumb-content">
          <p
            class="mb-1 manufacturer text-uppercase text-muted small font-heading"
            v-if="item.item.manufacturer && item.item.manufacturer.externalName"
            v-html="item.item.manufacturer.externalName"
          ></p>
          <a :href="item | itemURL(urlWithVariationId)" class="thumb-title small" :class="{ 'stretched-link': $ceres.config.global.shippingCostsCategoryId == 0 }">
            {{ item | itemName
            }}<!--
            --><span v-for="(attribute, index) in item.groupedAttributes" :key="`attr-${index}`">{{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}</span>
          </a>
          <hr class="hr-dark my-2" />

          <div class="categoryitem-produktdatenblatt small">
            <template v-if="item.variationProperties">
              <template v-for="(property, index) in item.variationProperties">
                <template v-if="property.properties">
                  <template v-for="(prop, propIndex) in property.properties">
                    <a v-if="prop.id == 44" :key="`prop-${index}-${propIndex}`" :href="prop.values.value" target="_blank">Produktdatenblatt&nbsp;&raquo;</a>
                  </template>
                </template>
                <a v-if="property.property && property.property.id == 44" :key="`single-prop-${index}`" :href="property.values.value" target="_blank">Produktdatenblatt&nbsp;&raquo;</a>
              </template>
            </template>
          </div>

          <div class="thumb-meta mt-2 d-flex flex-column align-items-start">
            <div class="d-flex align-items-center">
              <slot name="before-prices"></slot>
              <span class="feedback-stars-count"
                ><div v-if="item.item.feedbackCount > 0">({{ item.item.feedbackCount }})</div></span
              >
            </div>

            <div class="prices d-flex flex-row-reverse">
              <div v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.price.value" class="price-view-port">
                <del class="crossprice" v-if="item.prices.specialOffer">
                  {{ item.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                </del>
                <del class="crossprice" v-else>
                  {{ item.prices.rrp.unitPrice.formatted | itemCrossPrice }}
                </del>
              </div>

              <div class="price mr-1" :class="{ 'has-crossprice': hasCrossPrice }">
                <template v-if="item.item.itemType === 'set'"> {{ $translate("Ceres::Template.itemSetPrice", { price: itemSetPrice }) }} {{ $translate("Ceres::Template.itemFootnote") }} </template>
                <template v-else-if="itemGraduatedPriceisCheapestSorting">
                  {{ $translate("Ceres::Template.itemFromPrice", { price: itemPriceGraduated }) }}{{ $translate("Ceres::Template.itemFootnote") }}
                </template>
                <template v-else-if="itemGraduatedPricesalableVariationCount">
                  {{ $translate("Ceres::Template.itemFromPrice", { price: itemPriceGraduated }) }}{{ $translate("Ceres::Template.itemFootnote") }}
                </template>
                <template v-else> {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted") }}{{ $translate("Ceres::Template.itemFootnote") }} </template>
              </div>
            </div>
          </div>

          <slot name="after-prices"></slot>

          <div class="category-lowest-price small" v-if="item.prices.default.lowestPrice.value && hasCrossPrice">
            <span v-html="$translate('Ceres::Template.itemLowestPrice', { price: item.prices.default.lowestPrice.formatted })"></span>
          </div>

          <div class="category-unit-price small" v-if="!(item.unit.unitOfMeasurement === 'C62' && item.unit.content === 1)">
            <span>{{ item.unit.content }}</span>
            <span>&nbsp;{{ item.unit.names.name }}</span>
            <span v-if="item.variation.mayShowUnitPrice">&nbsp;| {{ basePrice }}</span>
          </div>
        </div>
      </slot>
      <!-- ./ITEM DETAILS  -->
    </div>
  </article>

  <article class="cmp cmp-product-thumb top-deal p-3" :data-testing="item.variation.id" v-else>
    <a :href="item | itemURL(urlWithVariationId)" class="d-flex flex-wrap h-100">
      <div class="special-text w-100 align-items-center d-flex justify-content-around">
        <span class="text-white p-2 bg-danger h4 font-weight-bold font-heading">{{ $translate("stabiloVueTheme::Catview.SpecialText") }}</span>
      </div>

      <p class="title font-weight-bold d-block text-dark px-3 font-heading">
        {{ item | itemName
        }}<!--
          --><span v-for="(attribute, index) in item.groupedAttributes" :key="`attr-${index}`">{{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}</span>
      </p>

      <!-- ITEM DETAILS -->
      <slot name="item-details">
        <div class="d-flex flex-wrap w-100 price-img-wrap">
          <div class="img text-center">
            <lazy-img :image-url="item.images && item.images.all && item.images.all[0] ? item.images.all[0].urlPreview || item.images.all[0].urlMiddle : ''" picture-class="img-fluid"></lazy-img>
          </div>

          <div class="prices d-flex flex-column justify-content-center align-items-end pb-3 pb-md-0">
            <div v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.price.value">
              <del class="h5 text-dark" v-if="item.prices.specialOffer">
                {{ item.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
              </del>
              <del class="h5 text-dark" v-else>
                {{ item.prices.rrp.unitPrice.formatted | itemCrossPrice }}
              </del>
            </div>

            <div class="price mr-1" :class="{ 'has-crossprice': hasCrossPrice }">
              <template v-if="item.item.itemType === 'set'"> {{ $translate("Ceres::Template.itemSetPrice", { price: itemSetPrice }) }} {{ $translate("Ceres::Template.itemFootnote") }} </template>
              <template v-else-if="itemGraduatedPriceisCheapestSorting">
                {{ $translate("Ceres::Template.itemFromPrice", { price: itemPriceGraduated }) }}{{ $translate("Ceres::Template.itemFootnote") }}
              </template>
              <template v-else-if="itemGraduatedPricesalableVariationCount">
                {{ $translate("Ceres::Template.itemFromPrice", { price: itemPriceGraduated }) }}{{ $translate("Ceres::Template.itemFootnote") }}
              </template>
              <template v-else> {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted") }}{{ $translate("Ceres::Template.itemFootnote") }} </template>
            </div>
          </div>
        </div>
      </slot>
    </a>
  </article>
</template>

<script>
import { mapState } from "vuex";
import CategoryImageCarousel from "./CategoryImageCarousel.vue";
import ItemStoreSpecial from "./ItemStoreSpecial.vue";
import { getSlotData } from "../../helper/getSlotData";
import { has } from "lodash";

export default {
  components: {
    CategoryImageCarousel,
    ItemStoreSpecial,
  },

  props: {
    decimalCount: {
      type: Number,
      default: 0,
    },
    imageUrlAccessor: {
      type: String,
      default: "urlMiddle",
    },
    itemData: {
      type: Object,
    },
    disableCarouselOnMobile: {
      type: Boolean,
    },
    paddingClasses: {
      type: String,
      default: null,
    },
    paddingInlineStyles: {
      type: String,
      default: null,
    },
    forceUrlWithVariationId: {
      type: Boolean,
      default: false,
    },
  },

  jsonDataFields: ["itemDataRef"],

  data() {
    return {
      showEnergyLabelModal: false,
    };
  },

  computed: {
    item() {
      return this.itemData || this.itemSlotData || this.itemDataRef;
    },

    itemSlotData: getSlotData("item-data"),

    /**
     * returns itemData.item.storeSpecial
     */
    storeSpecial() {
      return this.item && this.item.item ? this.item.item.storeSpecial : null;
    },

    /**
     * returns itemData.texts
     */
    texts() {
      return this.item ? this.item.texts : null;
    },

    itemPrice() {
      if (!this.item || !this.item.prices || !this.item.prices.default) {
        return "";
      }
      return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted");
    },

    basePrice() {
      return this.item && this.item.prices && this.item.prices.default ? this.item.prices.default.basePrice : "";
    },

    itemPriceGraduated() {
      if (!this.item || !this.item.prices) {
        return "";
      }

      let unitPrice;
      if (App.config.item.enableGraduatedPrices) {
        unitPrice = this.item.prices.graduatedPrices && this.item.prices.graduatedPrices.length > 0 ? this.item.prices.graduatedPrices[0].unitPrice : this.item.prices.default.unitPrice;
      } else {
        unitPrice = this.item.prices.default.unitPrice;
      }

      return this.$options.filters.specialOffer(unitPrice.formatted, this.item.prices, "unitPrice", "formatted");
    },

    itemGraduatedPriceisCheapestSorting() {
      return !!this.item.item && this.item.item.salableVariationCount > 1 && !!this.$ceres.isCheapestSorting;
    },

    itemGraduatedPricesalableVariationCount() {
      if (!this.item || !this.item.item || !this.item.prices) {
        return false;
      }
      return this.item.item.salableVariationCount == 1 && this.item.prices.graduatedPrices && this.item.prices.graduatedPrices.length > 1 && App.config.item.enableGraduatedPrices;
    },

    itemSetPrice() {
      if (!this.item || !this.item.prices || !this.item.prices.default) {
        return "";
      }
      return this.$options.filters.currency(this.item.prices.default.price.value, this.item.prices.default.currency);
    },

    urlWithVariationId() {
      return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
    },

    hasCrossPrice() {
      if (!this.item || !this.item.prices) {
        return false;
      }

      const hasRrpPrice =
        !!this.item.prices.rrp &&
        this.item.prices.rrp.unitPrice &&
        this.item.prices.default &&
        this.item.prices.default.unitPrice &&
        this.item.prices.rrp.unitPrice.value > this.item.prices.default.unitPrice.value;

      const hasBeforePrice =
        !!this.item.prices.specialOffer &&
        !!this.item.prices.default &&
        this.item.prices.default.unitPrice &&
        this.item.prices.specialOffer.unitPrice &&
        this.item.prices.default.unitPrice.value > this.item.prices.specialOffer.unitPrice.value;

      return hasRrpPrice || hasBeforePrice;
    },

    energyLabelValue() {
      let value = "";
      if (this.item.variationProperties) {
        this.item.variationProperties.forEach((group) => {
          (group.properties || []).forEach((prop) => {
            if (prop.id === 9 && prop.values && prop.values.value) {
              value = prop.values.value.trim();
            }
          });
        });
      }
      return value;
    },
    energyLabelType() {
      let type = "";
      if (this.item.variationProperties) {
        this.item.variationProperties.forEach((group) => {
          (group.properties || []).forEach((prop) => {
            if (prop.id === 8 && prop.values && prop.values.value) {
              type = prop.values.value.trim().toLowerCase();
            }
          });
        });
      }
      return type;
    },
    energyLabelImage() {
      if (!this.energyLabelValue || !this.energyLabelType) return null;
      if (this.energyLabelType === "lampen") {
        // Buchstabe immer groß schreiben
        let valueKey = this.energyLabelValue
          .toLowerCase()
          .replace("+", "plus")
          .replace("++", "plusplus");
        return this.$translate(`stabiloVueTheme::EnergyLabel.Lampen${valueKey}`);
      }
      if (this.energyLabelType === "eek20210301") {
        const valueKey = this.energyLabelValue.toLowerCase();
        return this.$translate(`stabiloVueTheme::EnergyLabel.EEK20210301${valueKey}`);
      }
      return null;
    },
    energyLabelModalImage() {
      let img = "";
      if (this.item.variationProperties) {
        this.item.variationProperties.forEach((group) => {
          (group.properties || []).forEach((prop) => {
            if (prop.id === 10 && prop.values && prop.values.value) {
              img = prop.values.value.trim();
            }
          });
        });
      }
      return img;
    },

    ...mapState({
      showNetPrices: (state) => state.basket.showNetPrices,
    }),

    hasSpecialProperty() {
      if (!this.item || !this.item.variationProperties) return false;
      // Prüfe auf Eigenschaft ID 273 (in beiden möglichen Strukturen)
      return this.item.variationProperties.some((group) => (group.property && group.property.id === 273) || (group.properties && group.properties.some((prop) => prop.id === 273)));
    },
  },
};
</script>
